import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/videos", label: "挠痒视频" },
  { to: "/articles", label: "趣味文章" },
  { to: "/community", label: "社区交流" },
  { to: "/about", label: "关于我们" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-secondary-900 text-background-100">
      <div className="mx-auto flex w-full max-w-[1240px] flex-col gap-8 px-4 py-10 md:flex-row md:items-start md:justify-between md:px-6 md:py-14">
        <div className="max-w-sm">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-foreground-950">
              <i className="ri-footprint-line text-lg"></i>
            </span>
            <span className="font-heading text-lg">挠脚心网站</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200/80">
            一个把轻松、好奇和一点点笑声放在一起的趣味内容平台。这里只有演示内容，用来展示一个温暖的小站可以长成什么样子。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-xs tracking-[0.2em] text-background-300/70">站内导航</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {quickLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="whitespace-nowrap text-sm text-background-100/85 transition-colors hover:text-primary-300"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-xs tracking-[0.2em] text-background-300/70">联系我们</p>
          <a
            href="mailto:hello@ticklefeet.demo"
            className="flex items-center gap-2 text-sm text-background-100/85 transition-colors hover:text-primary-300"
          >
            <i className="ri-mail-line text-base"></i>
            hello@ticklefeet.demo
          </a>
          <p className="flex items-center gap-2 text-sm text-background-100/70">
            <i className="ri-time-line text-base"></i>
            工作日 10:00 - 18:00 回复
          </p>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="mx-auto flex w-full max-w-[1240px] flex-col gap-2 px-4 py-5 text-xs text-background-300/70 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 挠脚心网站 · 本站内容均为虚构演示，不构成任何建议。</p>
          <p>请尊重他人边界，所有互动体验以双方自愿为前提。</p>
        </div>
      </div>
    </footer>
  );
}